// Theme: dracula
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'dracula',
  name: 'DRACULA',
  tagline: 'DRACULA',
  description: 'Tema classico Dracula. Roxo vibrante sobre azul-escuro profundo.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 1100,
  swatches: ['#282A36', '#BD93F9', '#44475A', '#F8F8F2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-sans theme-dracula'
  },
  colorVars: {
    '--accent': '#BD93F9',
    '--accent-foreground': '#282A36',
    '--background': '#282A36',
    '--border': '#34394f',
    '--card': '#44475A',
    '--card-border-active': 'rgba(189, 147, 249, 0.10)',
    '--card-completed': '#4C4F66',
    '--card-foreground': '#F8F8F2',
    '--card-glow': 'rgba(189, 147, 249, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#282A36',
    '--foreground': '#F8F8F2',
    '--hold-fill': '#BD93F9',
    '--input': '#34394f',
    '--modal-bg': '#282A36',
    '--modal-border': '#34394f',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#34394f',
    '--muted-foreground': '#D4DBEE',
    '--nav-active': '#BD93F9',
    '--nav-bg': '#282A36',
    '--popover': '#44475A',
    '--popover-foreground': '#F8F8F2',
    '--primary': '#BD93F9',
    '--primary-foreground': '#282A36',
    '--ring': '#BD93F9',
    '--secondary': '#34394f',
    '--secondary-foreground': '#F8F8F2',
    '--streak': '#BD93F9',
    '--success': '#22c55e',
    '--success-foreground': '#282A36',
    '--xp': '#BD93F9',
    '--xp-bg': '#44475A'
  },
  resolvedVars: {
    '--accent': '#BD93F9',
    '--accent-foreground': '#282A36',
    '--accent-foreground-hsl': '231 15% 18%',
    '--accent-foreground-oklch': 'from #282A36 l c h',
    '--accent-hsl': '265 89% 78%',
    '--accent-oklch': 'from #BD93F9 l c h',
    '--background': '#282A36',
    '--background-hsl': '231 15% 18%',
    '--background-oklch': 'from #282A36 l c h',
    '--border': '#34394f',
    '--border-hsl': '229 21% 26%',
    '--border-oklch': 'from #34394f l c h',
    '--border-w': '1px',
    '--card': '#44475A',
    '--card-border-active': 'rgba(189, 147, 249, 0.10)',
    '--card-completed': '#4C4F66',
    '--card-completed-hsl': '233 15% 35%',
    '--card-completed-oklch': 'from #4C4F66 l c h',
    '--card-foreground': '#F8F8F2',
    '--card-foreground-hsl': '60 30% 96%',
    '--card-foreground-oklch': 'from #F8F8F2 l c h',
    '--card-glow': 'rgba(189, 147, 249, 0.03)',
    '--card-hsl': '232 14% 31%',
    '--card-oklch': 'from #44475A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#282A36',
    '--destructive-foreground-hsl': '231 15% 18%',
    '--destructive-foreground-oklch': 'from #282A36 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F8F8F2',
    '--foreground-hsl': '60 30% 96%',
    '--foreground-oklch': 'from #F8F8F2 l c h',
    '--hold-fill': '#BD93F9',
    '--hold-fill-hsl': '265 89% 78%',
    '--hold-fill-oklch': 'from #BD93F9 l c h',
    '--input': '#34394f',
    '--input-hsl': '229 21% 26%',
    '--input-oklch': 'from #34394f l c h',
    '--modal-bg': '#282A36',
    '--modal-bg-hsl': '231 15% 18%',
    '--modal-bg-oklch': 'from #282A36 l c h',
    '--modal-border': '#34394f',
    '--modal-border-hsl': '229 21% 26%',
    '--modal-border-oklch': 'from #34394f l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#34394f',
    '--muted-foreground': '#D4DBEE',
    '--muted-foreground-hsl': '224 43% 88%',
    '--muted-foreground-oklch': 'from #D4DBEE l c h',
    '--muted-hsl': '229 21% 26%',
    '--muted-oklch': 'from #34394f l c h',
    '--nav-active': '#BD93F9',
    '--nav-active-hsl': '265 89% 78%',
    '--nav-active-oklch': 'from #BD93F9 l c h',
    '--nav-bg': '#282A36',
    '--nav-bg-hsl': '231 15% 18%',
    '--nav-bg-oklch': 'from #282A36 l c h',
    '--popover': '#44475A',
    '--popover-foreground': '#F8F8F2',
    '--popover-foreground-hsl': '60 30% 96%',
    '--popover-foreground-oklch': 'from #F8F8F2 l c h',
    '--popover-hsl': '232 14% 31%',
    '--popover-oklch': 'from #44475A l c h',
    '--primary': '#BD93F9',
    '--primary-foreground': '#282A36',
    '--primary-foreground-hsl': '231 15% 18%',
    '--primary-foreground-oklch': 'from #282A36 l c h',
    '--primary-hsl': '265 89% 78%',
    '--primary-oklch': 'from #BD93F9 l c h',
    '--radius': '16px',
    '--ring': '#BD93F9',
    '--ring-hsl': '265 89% 78%',
    '--ring-oklch': 'from #BD93F9 l c h',
    '--secondary': '#34394f',
    '--secondary-foreground': '#F8F8F2',
    '--secondary-foreground-hsl': '60 30% 96%',
    '--secondary-foreground-oklch': 'from #F8F8F2 l c h',
    '--secondary-hsl': '229 21% 26%',
    '--secondary-oklch': 'from #34394f l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#BD93F9',
    '--streak-hsl': '265 89% 78%',
    '--streak-oklch': 'from #BD93F9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#282A36',
    '--success-foreground-hsl': '231 15% 18%',
    '--success-foreground-oklch': 'from #282A36 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(265 89% 78% / 0.15)',
    '--xp': '#BD93F9',
    '--xp-bg': '#44475A',
    '--xp-bg-hsl': '232 14% 31%',
    '--xp-bg-oklch': 'from #44475A l c h',
    '--xp-hsl': '265 89% 78%',
    '--xp-oklch': 'from #BD93F9 l c h'
  }
}
